import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Success from '../../css/Success.png';
import unSuccess from '../../css/cross.jpg';

import { Button } from '../../components/Button/Button';
import { catchMessage, elseMessage } from '../../comman/Message';
import { userVerifiedEmailApi } from '../../services/auth/Auth';

const MobileVerifyEmail = () => {
  const { token } = useParams();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [icon, setIcon] = useState(null); // State to manage the icon

  useEffect(() => {
    const userVerifiedEmail = async () => {
      try {
        const res = await userVerifiedEmailApi({ token: token });
        // console.log("rrsponsse", res)
        if (res?.data?.status === 200) {
          setTitle('Congratulations!');
          setDescription('Your email has been successfully verified.');
          setIcon(Success); // Set success icon
        } else {
          setTitle('Condolences!');
          setDescription(res?.data?.message);
          setIcon(unSuccess); // Set failure icon
          // elseMessage(res);
        }
      } catch (err) {
        catchMessage(err);
      }
    };
    userVerifiedEmail();
  }, [token]);

  return (
    <div className="LoginArea">
      <h1 className="login_head">Neptune App</h1>
      <div className="LoginBox">
        <h5 className="mt-2">{title}</h5>
        {/* Render the icon dynamically */}
        {icon && <img className="success_logo" src={icon} alt="Icon" />}
        <p className="text-center fs-5">{description}</p>
        <div className="form_btn">
          {title === 'Congratulations!' &&
            <Button className="mt-5">
              <Link className="link_color" to="#">
                Login to your account
              </Link>
            </Button>}
        </div>
      </div>
    </div>
  );
};

export default MobileVerifyEmail;
